<template>
  <div class="purse-binding">
    <div class="use-defined-tab" v-loading="loading">
      <!-- 公司tabs -->
      <div class="corp-tabs-area">
        <div
          v-for="item in corpDalaList"
          :key="item.corpId"
          :class="`tab-item ${item.corpId === activeKey ? 'active' : ''}`"
          @click.stop="() => handleCorpTabClick(item)"
        >
          {{ item.corpName }}
        </div>
      </div>
      <div class="corp-tabs-pane">
        <!-- 账户tabs -->
        <div class="account-tabs-area">
          <div
            v-for="item in accountList"
            :key="item.accountType"
            :class="
              `tab-item tab-item-line ${
                item.accountType === activeAccountKey ? 'active' : ''
              }`
            "
            @click.stop="() => handleAccountTabClick(item)"
          >
            {{ item.accountName }}
          </div>
        </div>
        <div class="content-area">
          <!-- 连连账户 -->
          <accountCardLL
            v-if="activeAccountKey === 2"
            :activationVO="activationVO"
            :accountWithCorpInfoVO="accountWithCorpInfoVO"
            :accountWithUserInfoVO="accountWithUserInfoVO"
            :accountWithBankAccountVO="accountWithBankAccountVO"
            :accountWithModifyBankVo="accountWithModifyBankVo"
            :accountWithModifyPhoneVo="accountWithModifyPhoneVo"
            @handleReloadTab="handleReloadTab"
          />
          <!-- 锐锢账户 -->
          <accountCardRG
            v-if="activeAccountKey === 1"
            :activationVO="activationVO"
            :accountWithCorpInfoVO="accountWithCorpInfoVO"
            :accountWithUserInfoVO="accountWithUserInfoVO"
            :accountWithBankAccountVO="accountWithBankAccountVO"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accountCardLL from "./components/accountCardLL.vue";
import accountCardRG from "./components/accountCardRG.vue";
import {
  getCompanyList,
  getAccountInfo,
  getCheckOpenLian
} from "@/models/purseSet";

const totalAccountList = [
  {
    accountType: 2,
    accountName: "连连"
  },
  {
    accountType: 1,
    accountName: "锐锢"
  }
];

export default {
  data() {
    return {
      loading: false,
      activeKey: null, // 公司tabs active
      currentCorpTab: {
        corpId: "",
        corpName: ""
      }, // 记录当前corp信息
      corpDalaList: [],
      activeAccountKey: null, // 账户tabs active
      accountList: [],

      activationVO: {},
      accountWithCorpInfoVO: {},
      accountWithUserInfoVO: {},
      accountWithBankAccountVO: {},
      accountWithModifyBankVo: {},
      accountWithModifyPhoneVo: {}
    };
  },

  computed: {},

  methods: {
    /**
     * @description: 初始化公司列表
     */
    initCompanyList() {
      const supplierId = window.localStorage.getItem("supplier_id") || "";
      this.supplierId = supplierId;
      this.loading = true;
      getCompanyList({
        supplierId
      })
        .then(res => {
          const showList = (res.data || []).filter(item => item.show === 1); // 有钱袋的公司
          this.corpDalaList = showList;
          if (showList.length > 0) {
            // this.activeKey = res.data[0].corpId;
            this.handleCorpTabClick(showList[0]);
          }
          this.loading = false;
        })
        .catch(error => {
          this.$message.error(error.message);
          this.loading = false;
        });
    },

    /**
     * @description: 获取账户信息
     * @param {*} corpId
     * @param {*} bindAccountType
     */
    initAccountInfo(corpId, bindAccountType) {
      const params = {
        corpId,
        bindAccountType // 当前账户类型
      };
      this.activationVO = {};
      this.accountWithCorpInfoVO = {};
      this.accountWithUserInfoVO = {};
      this.accountWithBankAccountVO = {};
      this.accountWithModifyBankVo = {};
      this.accountWithModifyPhoneVo = {};
      getAccountInfo(params)
        .then(res => {
          console.log(">>>账户信息>>>>", res);
          const data = res.data;
          if (data && JSON.stringify(data) !== "{}") {
            this.activationVO = data.activationVO || {};
            this.accountWithCorpInfoVO = data.accountWithCorpInfoVO || {};
            this.accountWithUserInfoVO = data.accountWithUserInfoVO || {};
            this.accountWithBankAccountVO = data.accountWithBankAccountVO || {};
            this.accountWithModifyBankVo = data.accountWithModifyBankVo || {};
            this.accountWithModifyPhoneVo = data.accountWithModifyPhoneVo || {};
          }
        })
        .catch(error => {
          this.$message.error(error.message);
        });
    },

    /**
     * @description: 账户tabs切换
     */
    handleAccountTabClick(item) {
      if (this.activeAccountKey === item.accountType) return;
      this.activeAccountKey = item.accountType;
      if (item.accountType && this.currentCorpTab.corpId) {
        this.initAccountInfo(this.currentCorpTab.corpId, item.accountType); // 查询当前公司对应的钱袋信息
      }
    },

    /**
     * @description: 公司tab切换
     * @param {*} item
     */
    async handleCorpTabClick(item) {
      console.log("....点击....", item);
      if (this.activeKey === item.corpId) return;
      this.activeKey = item.corpId;
      this.currentCorpTab = item;
      try {
        const { data } = await getCheckOpenLian({ corpId: item.corpId });
        this.currentCorpTab = {
          ...item,
          ...data
        };
        const notOpenList = [...totalAccountList].filter(
          item => item.accountType !== 2
        );
        const currentAccountKey = !data.open ? 1 : 2;
        this.activeAccountKey = currentAccountKey;
        this.accountList = !data.open ? notOpenList : [...totalAccountList];
        this.initAccountInfo(item.corpId, currentAccountKey); // 查询当前公司对应的钱袋信息
      } catch (err) {
        this.$message.error(err.message || err);
      }
    },

    /**
     * @description: 刷新当前账户
     */
    handleReloadTab() {
      this.initAccountInfo(this.currentCorpTab.corpId, this.activeAccountKey); // 查询当前公司对应的钱袋信息
    }
  },

  created() {
    this.initCompanyList(); // 初始化查询公司列表
  },

  mounted() {},

  components: {
    accountCardLL,
    accountCardRG
  }
};
</script>

<style lang="scss" scoped>
.purse-binding {
  margin-left: -10px;
  margin-right: -10px;
  height: 100%;
  .use-defined-tab {
    height: 100%;
    .tab-item {
      padding: 13px 16px;
      font-size: 14px;
      color: #000000;
      display: inline-block;
      border: 1px solid #e9e9e9;
      cursor: pointer;
      min-width: 100px;
      text-align: center;
      background-color: #f0f2f5;
      &:first-child {
        border-radius: 10px 0 0 0;
      }
      &:last-child {
        border-left-color: transparent;
        border-radius: 0 10px 0 0;
      }
      &.active {
        color: #ff6224;
        background-color: white;
      }
    }
    .tab-item.tab-item-line {
      padding: 13px 0;
      border: none;
      background-color: transparent;
      text-align: center;
      &.active {
        position: relative;
        border-color: #ff6224;
        &::after {
          content: "";
          display: inline-block;
          position: absolute;
          width: 100px;
          height: 2px;
          background-color: #ff6224;
          bottom: -1px;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
    }
    .corp-tabs-pane {
      padding: 15px;
      height: calc(100% - 71px);
    }
    .account-tabs-area {
      border-bottom: 1px solid #e9e9e9;
    }
    .content-area {
      padding: 15px 0;
      height: calc(100% - 80px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/purseSetting/binding/binding.vue